// extracted by mini-css-extract-plugin
export default {"container":"about-security_container__92C5T"};